export default __webpack_public_path__ + "assets/static/data/app.model.json";